/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik'
import { login } from '../../../../apis/login-api'
import { useDispatch } from "react-redux";
import { userActions } from "../../../../redux/slices/login-slice";

const loginSchema = Yup.object().shape({
    username: Yup.string()
        .length(9, 'نام کاربری معتبر نیست')
        .required('نام کاربری الزامی میباشد'),
    password: Yup.string()
        .length(11, 'نام کاربری معتبر نیست')
        .required('رمزعبور الزامی میباشد'),
})

const initialValues: { username: string, password: string } = {
    username: '',
    password: '',
}

export function Login() {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues,
        validationSchema: loginSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            setLoading(true)
            try {
                const { data: auth }: any = await login(values.username, values.password)
                if (auth && auth.token) {
                    dispatch(userActions.Username(values.username))
                    dispatch(userActions.Password(values.password))
                    navigate("/otp_code");
                } else {
                    setStatus('نام کاربری یا رمز عبور اشتباه است')
                    setSubmitting(false)
                    setLoading(false)
                }
            } catch (error) {
                setStatus('اینترنت شما دچار مشکل است')
                setSubmitting(false)
                setLoading(false)
                console.log(error)
            }
        },
    })

    const userDetails = [
        {
            value: 'username',
            type: 'شماره پرونده '
        }, {
            value: 'password',
            type: 'رمزعبور'
        }]

    return (
        <form
            className='form mw-450px bg-body px-4 py-10 rounded align-items-center justify-content-center'
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_login_signin_form'>

            {/* begin::Heading */}
            <div className='text-center mb-11 align-items-center justify-content-center'>
                <h1 className='text-dark fw-bolder mb-3'>سامانه دریافت جواب</h1>
            </div>
            {/* begin::Heading */}
            {formik.status ? (
                <div className='mb-lg-15 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>{formik.status}</div>
                </div>
            ) : (
                <div className='mb-10 bg-light-info p-8 rounded'>
                    <div className='text-info text-center'>
                        <h4 className='text-info text-center'>لطفا شماره پرونده و رمزعبور را وارد کنید</h4> 
                        <h6 className="text-gray-600 fw-semibold fs-6 divcontents">(شماره پرونده در قبض دریافتی موجود است)</h6>
                    </div>
                </div>
            )}

            {/* begin::Form group */}
            {userDetails.map((item, index) => (
                <div key={index} className='fv-row mb-8 align-items-center justify-content-center text-center'>
                    <label className='form-label fs-6 fw-bolder text-dark'>{item.type}</label>
                    <input
                        placeholder={item.type}
                        {...formik.getFieldProps(item.value)}
                        className={clsx(
                            'form-control bg-transparent align-items-center justify-content-center text-center',
                            {
                                'is-invalid': item.value === 'username' ? formik.touched.username && formik.errors.username : formik.touched.password && formik.errors.password
                            },
                            {
                                'is-valid': item.value === 'username' ? formik.touched.username && !formik.errors.username : formik.touched.password && !formik.errors.password,
                            }
                        )}
                        type={item.value}
                        name={item.value}
                        autoComplete='off'
                    />
                    {item.value === 'username' ? formik.touched.username && formik.errors.username && (
                        <div className='fv-plugins-message-container'>
                            <span role='alert'>{formik.errors.username}</span>
                        </div>
                    ) : formik.touched.password && formik.errors.password && (
                        <div className='fv-plugins-message-container'>
                            <span role='alert'>{formik.errors.password}</span>
                        </div>
                    )}
                </div>
            ))}

            <div className='d-grid mb-10'>
                <button
                    type='submit'
                    id='kt_sign_in_submit'
                    className='btn btn-primary mt-5'
                    disabled={formik.isSubmitting || !formik.isValid}
                >
                    {!loading && <span className='indicator-label'>ادامه</span>}
                    {loading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            لطفا صبر کنید...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>
            </div>
            {/* end::Action */}
        </form>
    )
}
